import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'ramda'

import FormHandler, { useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import { useLinkTreeFormActions } from '../_form/LinkTreeFormHandler'
import Modal from '../../../../components/structure/Modal'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Text from '../../../../packages/kiti/components/presentation/Text'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Button from '../../../../packages/kiti/components/actions/Button'
import Select from '../../../../packages/kiti/components/form/Select'
import ChecklistSelect from '../../../../containers/checklists/select/ChecklistSelect'
import ServiceOrderStatusSelect from '../../../../containers/statuses/select/ServiceOrderStatusSelect'
import Line from '../../../../packages/kiti/components/helpers/Line'
import Form from '../../../../components/form/Form'

const PublicHistoryModalFilterComponent = ({ onClose, open, index, ...props }) => {
  const { t } = useTranslation('editLinkTreeItems')
  const { form, handleChangeIn } = useFormState()
  const { handleChange: handleChangeLinkTree } = useLinkTreeFormActions()

  const handleSubmit = () => {
    handleChangeLinkTree && handleChangeLinkTree(index, `configuration`, form)
    onClose()
  }

  return (
    <Modal width="32rem" noPadding open={open} onClose={() => onClose()}>
      <Form onSubmit={handleSubmit}>
        <Separator padding={0.5} bgColor="dark1">
          <Text bold align="center" color="white">
            {t('filterSelection')}
          </Text>
        </Separator>

        <Grid paddingGutter={0.5} margin={1} wrap>
          <Col width="100%">
            <Separator>
              <Text bold size="h5" align="left">
                {t('sort')}
              </Text>
            </Separator>
          </Col>

          <Col width="60%">
            <FormItem
              label={t('field')}
              path={['sort', 'field']}
              Input={Select}
              options={[
                { name: t('sortOptions.ID'), id: 'ID' },
                { name: t('sortOptions.YEARLY_ID'), id: 'YEARLY_ID' },
                { name: t('sortOptions.SCHEDULING'), id: 'SCHEDULING' },
                { name: t('sortOptions.END_DATE'), id: 'END_DATE' },
                { name: t('sortOptions.START_DATE'), id: 'START_DATE' }
              ]}
              disableEmptyOption
            />
          </Col>
          <Col width="40%">
            <FormItem
              label={t('order')}
              path={['sort', 'type']}
              Input={Select}
              options={[
                { name: t('orderOptions.ASC'), id: 'ASC' },
                { name: t('orderOptions.DESC'), id: 'DESC' }
              ]}
              disableEmptyOption
            />
          </Col>

          <Separator weight={2} />

          <Col width="100%">
            <Separator>
              <Text bold size="h5" align="left">
                {t('filters')}
              </Text>
            </Separator>
          </Col>

          <Col width="100%">
            <FormItem label={t('requiredChecklist')} path={['filter', 'questions']} Input={ChecklistSelect} multiple />
          </Col>

          <Col width="100%">
            <FormItem label={t('status')} path={['filter', 'statuses']} Input={ServiceOrderStatusSelect} multiple />
          </Col>
        </Grid>

        <Line />

        <Grid justify="flex-end" align="center" gap={0.5} padding={1}>
          {!isEmpty(form) && (
            <Text
              color="red"
              size="xsmall"
              onClick={() => {
                handleChangeIn([`filter`], [])
                handleChangeIn([`sort`], {
                  field: { name: t('sortOptions.ID'), id: 'ID' },
                  type: { name: t('orderOptions.ASC'), id: 'ASC' }
                })
              }}
            >
              {t('clearSelection')}
            </Text>
          )}

          <Col flex={1} />
          <Button type={'submit'}>{t('confirm')}</Button>
        </Grid>
      </Form>
    </Modal>
  )
}

const LinkTreeItemHistoryFilterModal = ({ item, ...prop }) => {
  const { t } = useTranslation('editLinkTreeItems')

  return (
    <FormHandler
      initialState={{
        sort: item?.configuration?.sort ?? {
          field: { name: t('sortOptions.ID'), id: 'ID' },
          type: { name: t('orderOptions.ASC'), id: 'ASC' }
        },
        filter: item?.configuration?.filter ?? [],
        isPublicHistory: item?.configuration?.isPublicHistory
      }}
    >
      <PublicHistoryModalFilterComponent {...prop} />
    </FormHandler>
  )
}

export default LinkTreeItemHistoryFilterModal
